angular.module('FlexyBeautyApp.controllers').controller('MarketplaceCtrl',
    ["$scope", "$sce", "UserSrv", "Brand",
        function ($scope, $sce, UserSrv, Brand) {
            $scope.dd = {
                marketplaceUrl: null
            };

            $scope.init = function () {
                $scope.getMarketplaceUrl();
            };

            $scope.getMarketplaceUrl = function () {
                if ($scope.dd.marketplaceUrl === null && $scope.ad.addons.sub.optionLeCiseau && $scope.checkMarketplaceComplianceIfNeeded()) {
                    return UserSrv.ssoConnexion(function (urlResponse) {
                            $scope.dd.marketplaceUrl = $sce.trustAsResourceUrl(urlResponse.url);
                        },
                        function (defaultUrl) {
                            $scope.dd.marketplaceUrl = $sce.trustAsResourceUrl(defaultUrl);
                        }
                    );
                } else {
                    $scope.dd.marketplaceUrl = $sce.trustAsResourceUrl(Brand.url.landingPage);
                }
            };

            $scope.init();
        }
    ]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/MarketplaceCtrl.js